export const theme = {
    color: {
        white: "#FFFFFF",
        lightGray: "#F5F5FA",
        gray: "#E4E6F0",
        silver: "#C4C4C4",
        darkGray: "#7E839A",
        slateGray: "#74788B",
        almostBlack: "#18181B",
        black: "#000000",
        lightBlue: "#D6E4FF",
        blue: "#0044CC",
    },

    breakpoints:{
        mobileMin: 319,
        mobile: 767,
        mobileMax: 932,
        laptop: 1279,
        desktop: 1400,
    },
};